import {AnyAction} from 'redux';
import {CLEAR_ALL_DAMAGE, DAMAGE_SOURCE_TYPE, REPAIR_STATION_AT_LOCATION, SET_INITIAL_DAMAGE} from '../action';


/**
 * damage all stations of a given type
 */
export function damageSourceType(type: string) : AnyAction
{
    return {type: DAMAGE_SOURCE_TYPE, payload: {type}};
}


/**
 * set the damage at the start of the year
 */
export function setInitialDamage(damaged: boolean[]) : AnyAction
{
    return {type: SET_INITIAL_DAMAGE, payload: {damaged}};
}


/**
 * clear all damage at the end of the year
 */
export function clearAllDamage() : AnyAction
{
    console.log('clearing all damage')

    return {type: CLEAR_ALL_DAMAGE};
}



/**
 * repair the damage at a location
 */
export function repairDamageAtLocation(location_id: number) : AnyAction
{
    return {type: REPAIR_STATION_AT_LOCATION, payload: {location_id}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/power-sources/damage.ts